import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Button from "../ui/Button";

type TemplateDetailsModalProps = {
  template: {
    id: string | number;
    name: string;
    content: string;
    isGlobal: boolean;
  } | null;
  isOpen: boolean;
  onClose: () => void;
};

const TemplateDetailsModal: React.FC<TemplateDetailsModalProps> = ({ template, isOpen, onClose }) => {
  if (!isOpen || !template) return null;
  console.log('Rendering TemplateDetailsModal with template:', template);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-2xl max-w-4xl w-full mx-4 max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-neutral-200">
          <div className="flex items-center gap-3">
            <h2 className="text-lg font-semibold text-black">{template.name}</h2>
            {template.isGlobal && (
              <span className="inline-flex shrink-0 items-center px-2.5 py-0.5 text-xs font-medium border rounded-full bg-primary-50 text-primary-800 border-primary-200">
                Global
              </span>
            )}
          </div>
          <button
            className="p-1 transition-colors rounded-md text-neutral-400 hover:text-primary-700 hover:bg-primary-50 focus:outline-none focus-visible:border-primary-700 border border-transparent"
            onClick={onClose}
            aria-label="Close"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

      

        {/* Content Preview */}
        <div className="flex-1 overflow-hidden p-4">
          <span className="text-sm font-medium text-neutral-700">Template Preview:</span>
          <div className="mt-2 border border-neutral-200 rounded-lg overflow-hidden h-[calc(100%-28px)]">
            <iframe
              srcDoc={`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </head>
      <body style="margin: 0; padding: 20px; background-color: #ffffff; font-family: Arial, sans-serif; font-size: 14px; color: #222;">
        ${template.content}
      </body>
    </html>
  `}
              title="Template Preview"
              className="w-full h-full min-h-[400px] bg-white"
              sandbox="allow-same-origin"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end p-4 border-t border-neutral-200">
          <Button
            variant="neutral"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TemplateDetailsModal;